import request from '@/utils/request'
import { NEWS, JRJBASE } from './constants'

// 频道列表
export const queryPartApi = (params) => {
  return request({
    url: NEWS + 'part/queryPart',
    headers: { 'Content-type': 'application/json' },
    params
  })
}

// 腾讯云上传加密桶 
export const loadUserEncryptBucket = () => {
  return request({
    url: JRJBASE + '/tencentOss/loadUserEncryptBucket',
    headers: { 'Content-type': 'application/json' }
  })
}
// 上传文件
export const uploadFile = (params) => {
  return request({
    url: JRJBASE + '/common/uploadFile',
    headers: { 'Content-Type': 'multipart/form-data' },
    params
  })
}
// 上传文件
export const uploadFileEncrypt = (params) => {
  return request({
    url: JRJBASE + '/common/uploadFileEncrypt',
    headers: { 'Content-Type': 'multipart/form-data' },
    params
  })
}

